// Google Analytics events. `gtag` is defined by /ga.js (see index.html and
// landing.html); where it is missing (dev server, a test) this does nothing.
// Never put personal data or score content in the parameters: formats,
// methods and counts only. The privacy page lists what is sent.

type Params = Record<string, string | number | boolean>;

export function track(event: string, params: Params = {}): void {
  try {
    (window as unknown as { gtag?: (...args: unknown[]) => void }).gtag?.('event', event, params);
  } catch {
    /* analytics must never break the app */
  }
}

/** A file's extension, lowercased, for the `format` parameter ("song.GP5" → "gp5"). */
export function fileFormat(name: string): string {
  const m = /\.([a-z0-9]{1,10})$/i.exec(name);
  return m ? m[1].toLowerCase() : 'unknown';
}
